import { css } from "styled-components";

const focus = css`
  left: calc(100% - 25vmin);
  width: 40vmin;
  height: 40vmin;
`;

export default focus;
